import { useAuth } from '@clerk/react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { AuthShell } from '../../components/ui/auth-shell/auth-shell.js';
import { SignInForm } from './sign-in-form.js';

export function SignInPage() {
  const { t } = useTranslation('common');
  const { isLoaded, isSignedIn } = useAuth();

  if (isLoaded && isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <AuthShell
      data-testid="auth-sign-in-page"
      ariaLabel={t('auth.signin.ariaLabel', 'Sign in')}
      eyebrow={t('auth.signin.eyebrow', 'Welcome back')}
      title={
        <>
          {t('auth.signin.title.a', 'Sign in to')}{' '}
          <span className="text-accent-lime">AgentBrush</span>
        </>
      }
      footer={
        <span>
          {t('auth.signin.noAccount', 'New to AgentBrush?')}{' '}
          <a href="/sign-up" className="text-accent-cyan transition-colors hover:underline">
            {t('auth.signin.createAccount', 'Create an account')}
          </a>
        </span>
      }
    >
      <SignInForm />
    </AuthShell>
  );
}
